import { render } from "./ClientConfigOptions.vue?vue&type=template&id=1084e48b"
import script from "./ClientConfigOptions.vue?vue&type=script&lang=js"
export * from "./ClientConfigOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__